import React, { createContext, useContext } from "react";
import type { UploadRequestFn } from "@/types";

/**
 * Sender 专用状态 Context
 * 仅包含 Sender 需要的字段，避免 messages 变化导致 Sender 重渲染和焦点丢失
 */
export interface ChatSenderStateContextType {
  loading: boolean;
  uploadRequest?: UploadRequestFn;
  /** Provider 级上传开关，默认布局可直接继承 config.allowUpload。 */
  allowUpload: boolean;
  /** Provider 级拖拽上传开关，默认布局仍可通过同名 prop 局部覆盖。 */
  draggable: boolean;
  /** Sender 输入框受控值 */
  senderValue: string;
  /** 更新 Sender 输入框值 */
  setSenderValue: React.Dispatch<React.SetStateAction<string>>;
}

export const ChatSenderStateContext =
  createContext<ChatSenderStateContextType | null>(null);

export const useChatSenderState = () => {
  const context = useContext(ChatSenderStateContext);
  if (!context) {
    throw new Error("useChatSenderState must be used within XAdkProvider");
  }
  return context;
};
